<template>
  <v-container fluid :class="distributionContainerClass">
    <v-slide-y-transition mode="out-in">
      <router-view />
    </v-slide-y-transition>

    <template v-if="addAccountModalContainer">
      <v-dialog v-model="addAccountModal" persistent width="390">
        <AddAccount @added="onAccountAdded" @cancelled="onCancelled" />
      </v-dialog>
    </template>
    <!-- <template v-if="addOrderModalContainer">
      <v-dialog v-model="addOrderModal" persistent width="400">
        <AddOrder @added="onOrderAdded" @cancelled="onCancelled" />
      </v-dialog>
    </template> -->
    <template v-if="addMultiOrderModalContainer">
      <v-dialog v-model="addMultiOrderModal" persistent width="800">
        <AddMultiOrderAccount
          @added="onMultiOrderAdded"
          @cancelled="onCancelled"
        />
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import AddAccount from "./components/accounts/add-accounts";
import AddOrder from "./components/orders/add-order";
import AddMultiOrderAccount from "./components/orders/add-multi-account-orders";
import { createModalMixin } from "../../dt-plugins/modal/modal.mixin";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as AccountActionTypes from "./store/accounts/types";
import * as OrderActionTypes from "./store/orders/types";
import { DistributionStoreNamespace as storeNS } from "./store";
import { childOfOrEqualDetails } from "./router/routes";
import * as I18nActionTypes from "../../store/app/i18n/types";
import { moduleRoutes } from './router/routes';
import { childOfOrEqualSome } from '../../router/functions';

export default {
  components: {
    AddAccount,
    AddOrder,
    AddMultiOrderAccount
  },
  mixins: [
    createModalMixin("addAccount"),
    createModalMixin("addOrder"),
    createModalMixin("addMultiOrder")
  ],
    mounted: function () {
    this.$store.dispatch(I18nActionTypes.INSERT_SYSTEM_LANGUAGE_SECTION, [
      "distribution",
      "label",
      "main"
    ]);
  },
  computed: {
    distributionModuleActive: function () {
      return !childOfOrEqualSome(moduleRoutes)(this.$route.name);
    },
    bookingContainerClass: function () {
      return {
        "cmp-booking-container": true,
        "dt-module": true,
        inactive: !this.distributionModuleActive,
      };
    },
    distributionContainerClass: function() {
      return {
        "distribution-container": true,
        "dt-module": true,
        inactive: !this.distributionModuleActive,
      };
    }
  },
  methods: {
    ...mapActions(storeNS, {
      [AccountActionTypes.AccountData.INSERT.SINGLE]:
        AccountActionTypes.AccountData.INSERT.SINGLE,
      [OrderActionTypes.DistributionOrderList.INSERT.SINGLE]:
        OrderActionTypes.DistributionOrderList.INSERT.SINGLE
    }),
    onCancelled: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
          account_id: undefined,
          external_table: undefined
        }
      });
    },

    onAccountAdded(account) {
      account.digital = account.digital ? 1 : 0;
      account.physical = account.physical ? 1 : 0;
      this[AccountActionTypes.AccountData.INSERT.SINGLE](account);
      this.onCancelled();
    },
    onOrderAdded(order) {
      this[OrderActionTypes.DistributionOrderList.INSERT.SINGLE](order);
      this.onCancelled();
    },
    onMultiOrderAdded(order) {
      this[OrderActionTypes.DistributionOrderList.INSERT.SINGLE](order);
      this.onCancelled();
    }
  }
};
</script>
